import { Handle, NodeProps, Position } from 'reactflow';
import { Wand2 } from 'lucide-react';
import { PipelineNodeData } from '../../types/pipeline';

export default function TransformationNode({ data, selected }: NodeProps<PipelineNodeData>) {
  return (
    <div
      className={`rounded-lg border bg-white px-3 py-2 shadow-sm ${
        selected ? 'border-amber-500 ring-2 ring-amber-200' : 'border-amber-200'
      }`}
    >
      <Handle type="target" position={Position.Left} className="!bg-amber-500" />
      <Handle type="source" position={Position.Right} className="!bg-amber-500" />
      <div className="flex items-center gap-2 text-sm font-semibold text-amber-700">
        <Wand2 className="h-4 w-4" />
        <span>{data.label}</span>
      </div>
      {data.description && (
        <p className="mt-1 text-xs text-slate-500">{data.description}</p>
      )}
    </div>
  );
}
